<template>
  <div>
    <v-row class="mx-0 mb-3" justify="space-between" align="center">
      <h3 class="title white--text">Scheduled Tasks</h3>
      <span v-if="serverEnvironment" class="caption white--text text--lighten-1">
        Server: {{ serverEnvironment }}
      </span>
    </v-row>

    <v-card :loading="loading">
      <v-card-text v-if="error" class="error--text">{{ error }}</v-card-text>

      <v-simple-table v-else>
        <thead>
          <tr>
            <th class="text-left">Task</th>
            <th class="text-left">Frequency</th>
            <th class="text-left">Environment</th>
            <th class="text-left">Active on server</th>
            <th class="text-left">Script</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="task in tasks" :key="task.id">
            <td class="align-top py-3">
              <div class="font-weight-medium">{{ task.name }}</div>
              <div class="caption grey--text text--darken-1 mt-1">{{ task.description }}</div>
            </td>
            <td class="align-top py-3">
              <div>{{ task.scheduleLabel }}</div>
              <div class="caption grey--text text--darken-1 mt-1">{{ task.schedule }}</div>
            </td>
            <td class="align-top py-3">{{ task.environment }}</td>
            <td class="align-top py-3">
              <v-chip small :color="task.runsOnServer ? 'success' : 'grey'" text-color="white">
                {{ task.runsOnServer ? "Yes" : "No" }}
              </v-chip>
            </td>
            <td class="align-top py-3 caption">{{ task.script }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/modules/admin/api";

export default {
  data() {
    return {
      loading: true,
      error: null,
      serverEnvironment: null,
      tasks: [],
    };
  },
  mounted() {
    this.loadTasks();
  },
  methods: {
    loadTasks() {
      this.loading = true;
      this.error = null;

      return api
        .getScheduledTasks()
        .then((response) => {
          this.serverEnvironment = response.data.serverEnvironment;
          this.tasks = response.data.tasks || [];
        })
        .catch((err) => {
          this.error = (err && err.data) || "Unable to load scheduled tasks.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
